import { render, staticRenderFns } from "./EntertainmentNicheIcon.vue?vue&type=template&id=08cae467&scoped=true"
import script from "./EntertainmentNicheIcon.vue?vue&type=script&lang=js"
export * from "./EntertainmentNicheIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cae467",
  null
  
)

export default component.exports